import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BuscaCobrosService } from '../../servicios/busca-cobros.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { BuscaCobros, BuscaCobrosInput, AuxJasper, ParametroJasper, Aguas, ObtenerUsuarioPorCargo, ObtenerUsuarioPorCargoInput, EnviarCorreo, RegistroBitacoraInput, FacturaMasiva, FacturacionData, MedioPagos, CatMedioPagos, PersonaClientes, CatCfdiUsos, Consumos, DatosCfdiFacturas, Privilegios} from '../../entidades/entidades';
import { JasperService } from './../../servicios/jasper.service';

import { ObtenerUsuarioPorCargoService } from 'app/servicios/obtener-usuario-por-cargo.service';
import Utils from '../../shared/utilerias/utils';

import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { FacturacionMasivaService } from '../../servicios/facturacion-masiva.service';

import { ConfirmationService, MessageService } from 'primeng/api';
import { DatosCfdiFacturasService } from 'app/servicios/datos-cfdi-facturas.service';
import { EnviarCorreoService } from 'app/servicios/enviar-correo.service';
import { PrivilegiosService } from 'app/servicios/privilegios.service';
import * as XLSX from 'xlsx';

declare var $: any;

@Component({
    selector: 'app-busca-cobros',
    templateUrl: './busca-cobros.component.html',
    styleUrls: ['./busca-cobros.component.css']
})

export class BuscaCobrosComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    buscaCobrosForm: FormGroup;
    mensajeForm: FormGroup;
    buscaCobrosTabla: any;
    private _jasperService: JasperService;
    selectedValue: string = '2';
    msgs: string;
    public registroBitacora = new RegistroBitacoraInput();
    public cobros_id: FacturaMasiva;

    _ids_factura: FacturaMasiva;
    validadorTabla: boolean = false;
    facturaMasivaBandera: boolean = false;
    facturaEnvio: boolean = false;
    facturacionData = new FacturacionData();
    public respuestaF: any;
    public facturaReferenciado:boolean = false;

    // tslint:disable-next-line: no-input-rename
    @Input('buscaCobros') buscaCobros: BuscaCobrosInput;
    // tslint:disable-next-line: no-output-rename
    @Output('buscaCobrosOutput') buscaCobrosOutput: EventEmitter<BuscaCobros[]>;
    @Output('cancelaCobrosOutput') cancelaCobrosOutput: EventEmitter<BuscaCobros[]>;


    public bCobros: BuscaCobrosInput;
    public catUsuarios: ObtenerUsuarioPorCargo[] = [];
    public usuarioSeleccionado = new ObtenerUsuarioPorCargo();
    public buscaCobro = new BuscaCobrosInput();
    public aguasProceso = new Aguas();
    public aguas$ = new EventEmitter<Aguas>();
    public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
    public enviaCorreo = new EnviarCorreo();
    public jasperInput$ = new EventEmitter<AuxJasper>();
    public tableWidget: any;
    public auxJasper: AuxJasper;
    public resultadoBusqueda: BuscaCobros[] = [];
    public usuarios: ObtenerUsuarioPorCargoInput;
    // public resultadoCalculo: CalculoParcialidadesConvenios[]=[];
    reimprimir = false;
    cancelar = false;
    refacturar = false;
    mostrar = false;
    btnGenerarPdf = false;
    first = 0;
    afacturar: number = 0;
    facturados: number = 0;
    resta: number = 0;
    btnRptCancelados = false;

    public tipoComprobante: string;
    public _folio: number;
    public idAgua: number;

    public id_factura_buscar: number;

    buscando: boolean = false;
    selec: any;
    checked: boolean;
    public registrosPagosFacEnviaCorreo: BuscaCobros[] = [];
    public datosCfdiFacturas: any[] = [];

    showdialog() {
        this.mostrar = true;
    }
    enviaC: boolean = false;
    handleChange(e) {
        this.enviaC = e.checked;
    }

    display: boolean = false;
    showmensaje() {
        this.display = true;
    }

    displayCancelados = false;
    showVisor(){
        this.displayCancelados = true;
    }

    public progressBar = false;
    showBar() {
        this.progressBar = true;
    }
    progressBarrita = false;
    showBarrita() {
        this.progressBarrita = true;
    }
    public progressBarEnvioCorreo = false;
    public progressBarPreparar = false;
    public contadorDeCorreos: number = 0;
    public totalCorreos: number = 0;
    public fallodeCorreo: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private buscaCobrosService: BuscaCobrosService,
        private catUsuariosService: ObtenerUsuarioPorCargoService,
        private route: ActivatedRoute,
        private jasp: JasperService,
        private router: Router,
        private messageService: MessageService,
        private registroBitacoraService: RegistroBitacoraService,
        private facturacionMasivaService: FacturacionMasivaService,
        private datosCfdiFacturasService: DatosCfdiFacturasService,
        private enviarCorreoService: EnviarCorreoService,
        private confirmationService: ConfirmationService,
        private privilegiosService: PrivilegiosService
    ) {
        this.buscaCobrosOutput = new EventEmitter(),
        this.cancelaCobrosOutput = new EventEmitter(),
        this._jasperService = jasp;

    }


    async ngOnInit() {
        this.facturaReferenciado = await this.getPrivilegios();
        this.buscaCobrosForm = this.formBuilder.group({
            folio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
            // serie : [undefined  ],
            cuentaAgua: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
            fechaIn: [undefined],
            fechaFin: [undefined],
            condicion: [undefined],
            numSolicitud: [undefined],
            idCajero: [undefined],
            derivada: [undefined]
        });

        this.mensajeForm = this.formBuilder.group({
            aplicados: [undefined],
            noplicados: [undefined]
        });


        this.getCatUsuarios();

    }


    // tslint:disable-next-line: use-life-cycle-interface
    ngOnChanges() {
        // if (this.buscaCobros) { this.buscaCobrosForm.patchValue(this.buscaCobros); }
        if (this.buscaCobros.condicion) {
            this.BuscaCobros();
        }


    }

    /* se trabajará con este metodo posteriromente   
    limpieza(){
       this.usuarioSeleccionado = null;
     } */
    clear() {
        this.messageService.clear();
        this.buscaCobrosForm.reset();
        this.buscaCobrosForm.patchValue({
            condicion: '2'
        })
        this.selectedValue = '2';

        this.usuarioSeleccionado = { id: 0, nombre: 'Select One', nombreUsuario: 'SELECCIONA...', cargo: null, departamento: null, direccion: null, idSucursal: null };

        //this.consultaLectura = null;
    }
    // ====================================================
    // Función busca Cobros
    // ====================================================
    async BuscaCobros() {
        try {

            this.first = 0;
            this.resultadoBusqueda.splice(0);
            if (this.buscando) {
                return;
            }
            this.buscando = true;


            if (this.aguasProceso.cuentaAgua != null)
                this.buscaCobros.cuentaAgua = this.aguasProceso.cuentaAgua.toString();

            if (this.usuarioSeleccionado.id != null && this.usuarioSeleccionado.id != 0)
                this.buscaCobrosForm.patchValue({
                    idCajero: this.usuarioSeleccionado.id
                });


            if (this.usuarioSeleccionado.id === 0 || this.usuarioSeleccionado.id === null) {
                this.usuarioSeleccionado.id = null;
                this.buscaCobrosForm.patchValue({
                    idCajero: this.usuarioSeleccionado.id
                });
            }

            this.buscaCobros = this.buscaCobrosForm.value;


            if (this.buscaCobros.cuentaAgua == undefined && this.buscaCobros.fechaFin == undefined &&
                this.buscaCobros.fechaIn == undefined && this.buscaCobros.folio == undefined &&
                this.buscaCobros.idCajero == undefined && this.buscaCobros.numSolicitud == undefined
                && this.buscaCobros.derivada == undefined) {
                return;
            }

            // if (this.aguasProceso.cuentaAgua == null){
            //   this.muestraMensaje.error('Ingresa algún dato para buscar', 'top', 'center'); return
            // }  

            if (this.buscaCobros.condicion === '1') {
               
                this.cancelar = true;
                this.reimprimir = true;
                this.refacturar = false;
                this.checked = true;
                this.facturaMasivaBandera = false;
                this.facturaEnvio = true;
                this.btnGenerarPdf = true;
                this.btnRptCancelados = false;
            
            } else if (this.buscaCobros.condicion === '2') {
                
                this.cancelar = true;
                this.reimprimir = true;
                this.refacturar = true;
                this.facturaMasivaBandera = true;
                this.facturaEnvio = false;
                this.btnGenerarPdf = false;
                this.btnRptCancelados = false;


                //this.getSelecteditem();
            } else if (this.buscaCobros.condicion === '3') {
                
                this.cancelar = false;
                this.reimprimir = false;
                this.refacturar = false;
                this.facturaMasivaBandera = false;
                this.facturaEnvio = false;
                this.btnGenerarPdf = false;
                this.btnRptCancelados = true;
                
            }

            if (!this.buscaCobros.condicion)
                throw new Error('Seleccione el tipo de pagos a buscar  \n *Facturados   \n *A Facturar  \n *Cancelados.');

            this.progressBarPreparar = true;

            const datoretorno = await this.buscaCobrosService
                .add(this.buscaCobros)
                .toPromise();
            const numero = Object.keys(datoretorno);
            for (var j of numero) {
                datoretorno[j].selected = false;
                //console.log(j);
            }

            // this.buscaCobrosTabla = datoretorno;
            this.resultadoBusqueda.push(datoretorno);
            
            // this.limpiar();

            this.validadorTabla = false;
            this.clear();
            if (this.resultadoBusqueda[0] != null) {
                if (this.resultadoBusqueda[0][0] == null) {
                    this.validadorTabla = true;
                    this.messageService.clearObserver;
                    this.messageService.add({ severity: 'warn', summary: 'No se encontraron', detail: 'resultados para esta combinación de búsqueda.' });
                }
            }
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center"); 
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            this.buscando = false;
            this.progressBarPreparar = false;
        }
    }

    async childAguaBuscaCuentas(aguas: Aguas) {
        try {

            await this.aguas$.emit(aguas);
            this.aguasProceso = aguas;
            this.idAgua = aguas.id;
            this.buscaCobrosForm.patchValue({
                cuentaAgua: aguas.cuentaAgua
            });

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childAguas");
        }
    }


    async limpiar() {
        try {
            this.resultadoBusqueda = [null];
            this.facturaMasivaBandera = null;
            this.facturaEnvio = null;  
            this.aguasProceso = new Aguas();
            //this.facturaReferenciado = false;

            //this.buscaCobros = new BuscaCobros();
            await this.aguas$.emit(this.aguasProceso);
            await this.buscaCobrosForm.reset();

            //this.resultadoBusqueda.splice(0); 
            this.buscaCobrosForm.patchValue({
                condicion: '2'
            })
            this.selectedValue = '2';

            this.validadorTabla = false;

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por limpiar");
        }

    }

    /*se trabajará con este metodo posteriromente   
    private newMethod() {
        this.usuarioSeleccionado = null;
      } */

    // ====================================================
    // child enviar-correo 
    // ====================================================
    async enviarCorreo(row: any) {
        try {

            //console.log('esto llego---------------------->>>>', row);
            const datosenviarCorreo = new EnviarCorreo();
            datosenviarCorreo.idFactura = row.facturaId;
            datosenviarCorreo.correo = "";
            datosenviarCorreo.correocopia = "";
            //console.log('ESTO DEBE EMITIR', datosenviarCorreo);
            await this.datosenviarCorreo$.emit(datosenviarCorreo);

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por enviarCorreo");
        }
    }


    async getCatUsuarios() {
        try {
            this.usuarios = new ObtenerUsuarioPorCargoInput;

            this.usuarios.idCargo = null;
            this.usuarios.idEstatus = 1;

            let datoRetorno = await this.catUsuariosService.getBusquedas(this.usuarios).toPromise();
            this.catUsuarios = datoRetorno;
            this.catUsuarios.unshift({ id: 0, nombre: 'SELECCIONA...', nombreUsuario: 'SELECCIONA...', cargo: null, departamento: null, direccion: null, idSucursal: null });

        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getCatUsuarios");
        }
    }



    // ====================================================
    // Metodos para emitir al padre el renglon seleccionado
    // ====================================================

    async selectRowFacturar(row: any) {
        try {
            const eje = document.getElementsByName('modulo');
            this.selec = row;
            let afacturar = row;
            afacturar.condicion = '1';
            // SE EMITE EL RENGLON SELECCIONADO
            this.buscaCobrosOutput.emit(afacturar);
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por selectRowFacturar');
        }
    }


    // CONFIRMA EL ENVIO DE FACTURAS POR CORREO SEGUN LOS REGISTROS SELECCIONADOS
    async confirmaEnvio() {
        try {
            this.registrosPagosFacEnviaCorreo = [];
            this.datosCfdiFacturas = [];
    
            if (!this.resultadoBusqueda || this.resultadoBusqueda.length === 0)
                throw new Error('Seleccione registros a enviar por correo');

            const numero = Object.keys(this.resultadoBusqueda[0]);

            for (var j of numero) {
                if (this.resultadoBusqueda[0][j].selected === true) {
                    this.registrosPagosFacEnviaCorreo.push(this.resultadoBusqueda[0][j]);
                };
            };

            if (this.registrosPagosFacEnviaCorreo.length === 0)
                throw new Error('Seleccione registros a enviar por correo');
            
            // Filtrar los datos de las facturas que tengan correo , correos validos y descartamos correos con comas o puntos y comas , tomamos rfc distinto a gnerico XAXX010101000
            let datosConCorreo = this.registrosPagosFacEnviaCorreo.filter((row) => row.correoElectronico !== null && row.correoElectronico !== '' && row.rfc !== 'XAXX010101000' && row.correoElectronico.indexOf(',') === -1 && row.correoElectronico.indexOf(';') === -1).map((row) => row);
            
            if(datosConCorreo.length > 0){
                this.totalCorreos = datosConCorreo.length;
                this.confirmationService.confirm({
                    header: "Confirmación",
                    message: "Solo se enviaran los datos con correos.\n" + this.totalCorreos + " registros con correo" + " ¿Desea continuar?",
                    accept: async () => {
                        this.progressBarEnvioCorreo = true;
                        this.contadorDeCorreos = 1;
                        for (const item of datosConCorreo) {
                            let datosEnviarCorreo = new EnviarCorreo();
                            datosEnviarCorreo.idFactura = item.facturaId;
                            datosEnviarCorreo.correo = item.correoElectronico;
                            datosEnviarCorreo.enviosFactura = true;
                            
                            // simulamos espera de envio de correo con 3 segundos
                            //await new Promise(resolve => setTimeout(resolve, 1000));
                            try {
                                await this.addEnviarCorreo(datosEnviarCorreo);
                            } catch (error) {
                                this.muestraMensaje.error(error.message, "top", "center");
                                this.fallodeCorreo  = true;
                            }
                            
                            this.contadorDeCorreos++; 
                        }
                        
                        if(this.fallodeCorreo){
                            this.muestraMensaje.warning('Algunos correos no pudieron ser enviados', "top", "center");
                        }else{  
                            this.muestraMensaje.notification("Envió exitoso", "top", "center");
                        }

                        this.limpiarCheckboxes();
                        this.progressBarEnvioCorreo = false;
                    },
                    reject: () => {
                        return;
                    },
                    key: "positionDialog"
                });
            }
            else{

                this.muestraMensaje.error('No se cuenta con correos registrados en los registros seleccionados', "top", "center");
            };

        } catch (error) {
            this.muestraMensaje.error(error.message, "top", "center");
        }finally{
            this.progressBarEnvioCorreo = false;
            this.progressBarPreparar = false; 
        }
        ;
    };


    // se crea accion para enviar factura por correo
    async selectRowEnviaFacturaEmail(row: any) {
        try {
           
            // obtenememos los datos de la factura para obtener el correo registrado
           // const datoRetornoCfdi = await this.datosCfdiFacturasService.getSingle(row.id).toPromise();

            let datosEnviarCorreo = new EnviarCorreo();
            datosEnviarCorreo.idFactura = row.facturaId;
            datosEnviarCorreo.correo = row.correoElectronico;
            datosEnviarCorreo.enviosFactura = true;

            //validamos si existe un correo en el resigro para enviarlo o correo valido o sin comas o puntos y comas
            if(datosEnviarCorreo.correo === null || datosEnviarCorreo.correo === '' || datosEnviarCorreo.correo.indexOf(',') !== -1 || datosEnviarCorreo.correo.indexOf(';') !== -1){
                throw new Error('No se cuenta con un correo registrado o el correo no es valido');
            }
            this.progressBarEnvioCorreo = true;
            await this.addEnviarCorreo(datosEnviarCorreo);

            this.muestraMensaje.notification("Envió exitoso", "top", "center");

        }catch (error) {
            this.muestraMensaje.error(error.message, "top", "center");
        } finally {
            console.log('Paso por selectRowFacturar');
            this.progressBarEnvioCorreo = false;
        }
    }

    async addEnviarCorreo(enviarCorreo) {
        try {
          const datoretorno = await this.enviarCorreoService.add(enviarCorreo).toPromise();
          let respuesta = datoretorno;
          this.progressBar = false;
          if (respuesta.toString() == "OK") { 
            //this.muestraMensaje.notification("Envió exitoso", "top", "center");
          }
          else {
            throw new Error(respuesta.toString());
          }
        } catch (e) {
           throw new Error(e.message);
        }
      };


    async selectRowCancelar(row: any) {
        try {
            const eje = document.getElementsByName('modulo');
            this.selec = row;
            let acancelar = row;
            acancelar.condicion = '3';
            // SE EMITE EL RENGLON SELECCIONADO
            await this.buscaCobrosOutput.emit(acancelar);
            await this.resultadoBusqueda.splice(0);
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por selectRowCancelar');
        }
    }

    async selectRowImprimir(row: any) {
        try {
            if (!row.facturaId)
                throw new Error('Genere el comprobante primero');

            this.mostrar = false;
            let reporte;
            this._folio = row.folio;
            const eje = document.getElementsByName('modulo');
            this.selec = row;
            // if (this.buscaCobros.condicion === '1') {
                this.reimprimir = true;
                reporte = '001_Factura';
                this.tipoComprobante = 'FACTURA';
                await this.imprimeFactura(row.facturaId, reporte, this.reimprimir);
            // } else if (this.buscaCobros.condicion === '2') {
            //     reporte = '002_RecibosinTimbre';
            //     this.tipoComprobante = 'RECIBO';
            //     this.reimprimir = false;
            //     await this.imprimeFactura(row.facturaId, reporte, this.reimprimir);
            // }
            if (this.buscaCobros.condicion === '1') {
                const  datoretorno = await this.datosCfdiFacturasService.getObtenerXml(row.facturaId).toPromise();
                const xml = exportFile(datoretorno.nombre , datoretorno.adjuntoXml);
            }


            await this.enviarCorreo(row);
 
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log('Paso por selectRowImprimir');
        }
    }

    limpiarCheckboxes(){
        const numero = Object.keys(this.resultadoBusqueda[0]);
        for (var j of numero) {
            this.resultadoBusqueda[0][j].selected = false;
        };
    }

    async imprimeFactura(id_Factura, reporte, reimprimir) {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = reporte + '';
        this.auxJasper.JasperReport.tipo = 'pdf';
        // -- Parametros --s
        const id_factura = new ParametroJasper();
        id_factura.nombre = '_id_factura';
        id_factura.valor = id_Factura + '';
        let reimpresion = new ParametroJasper();
        reimpresion.nombre = 'reimpresion';
        reimpresion.valor = reimprimir + "";
        let timbre = new ParametroJasper();
        timbre.nombre = 'timbre';
        if (this.buscaCobros.condicion === '1') 
            timbre.valor = true + "";
        else
            timbre.valor = false + "";
        
        await this.auxJasper.ParametroJasper.push(reimpresion);
        await this.auxJasper.ParametroJasper.push(id_factura);
        await this.auxJasper.ParametroJasper.push(timbre);

        this.jasperInput$.emit(this.auxJasper);

        this.showdialog();

        if (this.idAgua)
            this.registroBitacora.idAgua = this.idAgua;
        this.registroBitacora.accion = "SE REIMPRIME " + this.tipoComprobante + " FOLIO N°: " + this._folio;
        const datRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();

    }

    async recarga() {
         try {
            if (this.buscaCobrosForm.invalid) {
                throw new Error("No paso las validaciones.");
            }
            this.buscaCobro = this.buscaCobrosForm.value;

            //Se Valida que se tenga capturado, al menos, un criterio de busqueda.

            if (Utils.isEmpty(this.buscaCobro.folio)) {
                this.buscaCobros.folio = undefined;
            }
            if (Utils.isEmpty(this.buscaCobro.cuentaAgua)) {
                this.buscaCobros.cuentaAgua = undefined;
            }
            if (Utils.isEmpty(this.buscaCobro.fechaIn)) {
                this.buscaCobro.fechaIn = undefined;
            }
            if (Utils.isEmpty(this.buscaCobro.fechaFin)) {
                this.buscaCobro.fechaFin = undefined;
            }
            if (Utils.isEmpty(this.buscaCobro.numSolicitud)) {
                this.buscaCobro.numSolicitud = undefined;
            }
            if (Utils.isEmpty(this.buscaCobro.idCajero)) {
              this.buscaCobro.idCajero = undefined;
          }
          if (Utils.isEmpty(this.buscaCobro.derivada)) {
            this.buscaCobro.derivada = undefined;
        }



            if (
                Utils.isEmpty(this.buscaCobro.folio) &&
                Utils.isEmpty(this.buscaCobro.cuentaAgua) &&
                Utils.isEmpty(this.buscaCobro.fechaIn) &&
                Utils.isEmpty(this.buscaCobro.fechaFin) &&
                Utils.isEmpty(this.buscaCobro.numSolicitud) &&
                Utils.isEmpty(this.buscaCobro.idCajero) &&
                Utils.isEmpty(this.buscaCobro.derivada)
            ) {
                throw new Error("Debe capturar por lo menos un criterio de búsqueda.");
            }

            this.buscaCobrosOutput.emit(null);

        } catch (e) {
            this.resultadoBusqueda.push(null);
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("paso por addBuscaCobros")
        }
    }



    async selectAll(e) {

        try {
            var isChecked = e.currentTarget.checked;


            const numero = Object.keys(this.resultadoBusqueda[0]);
            for (var j of numero) {
                if (isChecked)
                    this.resultadoBusqueda[0][j].selected = true;
                else
                    this.resultadoBusqueda[0][j].selected = false;
            }

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por selectAll');
        }

    }

    async GenerarXmlPdfsHilo() {

        try {
            if (!this.resultadoBusqueda || this.resultadoBusqueda.length === 0)
                throw new Error('No hay PDF´s Que Generar!')
            this.showBarrita();

            const numero = Object.keys(this.resultadoBusqueda[0]);
            this.muestraMensaje.notification('GENERANDO ' + numero.length + ' ARCHIVOS', "top", "center");
            const datoretorno = await this.facturacionMasivaService
                .tareaGenerar(this.resultadoBusqueda[0])
                .toPromise();
            
            if (datoretorno)
                this.progressBarrita = false;

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por FacturaMasiva');
            this.progressBarrita = false;
        }

    }


    async FacturaMasiva() {
        try {
            let registrosFacturar: BuscaCobros[] = [];
            // console.log('HEY', this.resultadoBusqueda);
            if (!this.resultadoBusqueda || this.resultadoBusqueda.length === 0)
                throw new Error('Seleccione pagos a facturar')

            const numero = Object.keys(this.resultadoBusqueda[0]);

            for (var j of numero) {
                if (this.resultadoBusqueda[0][j].selected === true) {
                    registrosFacturar.push(this.resultadoBusqueda[0][j]);
                }
            }

            if (registrosFacturar.length === 0)
                throw new Error('Seleccione pagos a facturar')

            this.showBar();
            let metodoPago = new CatMedioPagos();
            let receptor = new PersonaClientes();
            let usoCfdi = new CatCfdiUsos();

            for (var j of numero) {
                if (this.resultadoBusqueda[0][j].selected === true) {
                    this.afacturar = this.afacturar + 1;

                    this.facturacionData.id = this.resultadoBusqueda[0][j].id;
                    this.facturacionData.metodoPago = metodoPago;
                    this.facturacionData.receptor = receptor;
                    this.facturacionData.usoCFDI = usoCfdi;

                    const datoretorno = await this.datosCfdiFacturasService
                        .add(this.facturacionData)
                        .toPromise();


                    if (datoretorno) {
                        this.respuestaF = datoretorno;

                        if (this.respuestaF.estatus == 'OK')
                            this.facturados = this.facturados + 1;

                    }
                }
            }

            this.resta = (this.afacturar - this.facturados);

            this.progressBar = false;
            this.mensajeForm.patchValue({
                aplicados: 'FOLIOS FACTURADOS ' + this.facturados,
                noplicados: 'FOLIOS SIN FACTURAR ' + this.resta
            });


            await this.showmensaje();
            await this.BuscaCobros();

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por FacturaMasiva');
            this.progressBar = false;

        };

    }
    async getPrivilegios() {
        try {
          let objUrl = new Privilegios();
          objUrl.uuid = 'ef285c70-3c71-49a9-bc88-01b55923c4fe';
          let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise();
          return conPrivilegio;
        } catch (e) {
          if (e.response) throw { message: e.response.data };
          else throw e;
        } finally {
          console.log("Paso por getPrivilegios");
        }
      }


    async exportarTabla () 
    {
        try {

            if (Object.keys(this.resultadoBusqueda).length == 0)
                throw new Error('Realice una búsqueda primeramente.');
            this.progressBar = true;
            
            const aux = Array.isArray(this.resultadoBusqueda[0]) ? this.resultadoBusqueda[0] : [this.resultadoBusqueda[0]];
            const data = Object.values(this.resultadoBusqueda[0]).map(row => ({
                'Folio': row.folio,
                'Serie': row.serie,
                'Fecha de Pago': row.fechaPago,
                'Importe': row.importe,
                'Contrato': row.cuentaAgua,
                'Cajero': row.cajero,
                'Estatus Pago': row.estatusCobro,
                'RFC': row.rfc,
                'Correo Electronico': row.correoElectronico,
                'Estatus Comprobante': row.estatusFactura 
            }));
            
            
          
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
          
            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
            const blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Facturacion.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
 
          } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
          } finally {
            console.log("Paso por exportarTabla");
            this.progressBar = false;
          }
    }

    s2ab(s){
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
      }
    
    async generarRptCancelados(row: any){
        try{
            this.auxJasper = new AuxJasper();
            this.auxJasper.JasperReport.nombreReporte = '046_CanceladosPorFolio';
            this.auxJasper.JasperReport.tipo = 'pdf';

            let parametroJasper = new ParametroJasper();
            parametroJasper.nombre = '_folio';
            parametroJasper.valor = row.folio;
            await this.auxJasper.ParametroJasper.push(parametroJasper);

            this.showVisor();

        }catch (e){
            this.muestraMensaje.error(e.message, "top", "center");
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        }finally{
            console.log('Paso por generarRptCancelados');
        }
    }
    
}

   



function exportFile(fileName: string, fileContent: string): void {
    // Crear un blob con el contenido del archivo
    const blob = new Blob([fileContent], { type: 'application/xml' });
  
    // Crear un enlace temporal para descargar el archivo
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
  
    // Simular el clic en el enlace para iniciar la descarga
    document.body.appendChild(link); // Agregar el enlace temporal al DOM
    link.click(); // Forzar el clic para descargar
    document.body.removeChild(link); // Eliminar el enlace del DOM
  }
